import { UserCartService } from './user-cart.service';
import { QuestionnaireService as LLCQuestionnaireService } from './questionnaire/questionnaire.service';
import { Injectable } from '@angular/core';
import { AppService, createAppState } from '../state/app';
import { CookieService } from 'ngx-cookie';
import { QueueService, IQueueEntry, TrackJsErrorLogService } from '@legalzoom/business-formation-sdk';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { AuthService } from './auth.service';
import { UtilityService } from './utility.service';
import { TrackSEMDataService } from '../services/tracking/track-sem-data.service';
import { Chapter, PagePath } from '../models/page-model';
import { LLC } from '../models/questionnaire-model';
import { ProductName } from '../constants/product-domain';
import { OrderService } from './order.service';
import { ProcessingOrderService } from './processing-order.service';
import { QuestionnaireAnswerService } from './questionnaire-answer.service';
import { ExperimentsService } from './experiments/experiments.service';
@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  private currentRoutePath: string;
  private isReloaded = false;

  constructor(
    private appService: AppService,
    private cookieService: CookieService,
    private environmentService: EnvironmentService,
    private authService: AuthService,
    private processingOrderService: ProcessingOrderService,
    private userCartService: UserCartService,
    private orderService: OrderService,
    private router: Router,
    private llcQuestionnaireService: LLCQuestionnaireService,
    private questionnaireAnswerService: QuestionnaireAnswerService,
    private queueService: QueueService,
    private utilityService: UtilityService,
    private trackSemDataService: TrackSEMDataService,
    private trackjsErrorLogService: TrackJsErrorLogService,
    private experimentsService: ExperimentsService
  ) { }

  initializeApp(currentRoutePath: string): Observable<boolean> {
    this.currentRoutePath = `.${currentRoutePath}`;

    const readOnlyAppState = this.appService.app;

    const sessionId = this.cookieService.get(this.environmentService.getTimestringCookie()) || readOnlyAppState.sessionId;

    const authToken = this.utilityService.getAuthTokenConsultationCookie() || readOnlyAppState.accessToken;
    const customerId = this.utilityService.getCustomerIdConsultationCookie() || readOnlyAppState.customerId;

    const tempProcessingOrderId = this.utilityService.getIntParamFromQueryString('uo') || readOnlyAppState.processingOrderId;
    const tempCartId = this.utilityService.getIntParamFromQueryString('cartId') || readOnlyAppState.cartId;
    const tempOrderId = this.utilityService.getIntParamFromQueryString('orderId') || readOnlyAppState.orderId;

    const kenshooID = this.utilityService.getStringParamFromQueryString('kid');
    if (kenshooID) {
      this.trackSemDataService.setSEMCookies();
    }

    if (this.experimentsService.getGloDesignTest() && this.isReloaded) {
      return of(true);
    }
    this.isReloaded = true;
    if (sessionId && authToken && customerId) {
      console.log('App Initialization: SessionId: ' + sessionId + ' AuthToken: ' + authToken + ' CustomerId: ' + customerId);

      this.appService.sessionId = sessionId;
      this.appService.accessToken = authToken;
      this.appService.customerId = customerId;

      this.queueService.add(this.authService.prepareGetCustomerAndSession(sessionId, authToken, customerId));
      const queueEntries: IQueueEntry[] = [];
      if (tempCartId) {
        queueEntries.push(this.userCartService.prepareGetCartById(this, this.appService, tempCartId, customerId, ProductName.LLC));
      }

      if (tempProcessingOrderId) {
        queueEntries.push(this.processingOrderService.prepareGetProcessingOrderById(this, this.appService, tempProcessingOrderId, authToken, customerId, ProductName.LLC));

        queueEntries.push(
          this.llcQuestionnaireService.prepareGetQuestionnaireStorage(this, customerId, tempProcessingOrderId, authToken, ProductName.LLC, (data) => {
            this.setllcInSession(data);
          })
        );

        queueEntries.push(this.questionnaireAnswerService.prepareGetUserAnswers(this, customerId, tempProcessingOrderId, ProductName.LLC));
      }

      if (tempOrderId) {
        queueEntries.push(this.orderService.prepareGetOrderById(this, this.appService, tempOrderId, customerId, authToken, ProductName.LLC));
      }

      if (queueEntries && queueEntries.length > 0) {
        this.queueService.add(queueEntries);
      }

      this.queueService.add(
        this.questionnaireAnswerService.prepareDeleteQuestionnaireAnswers(this, customerId, ProductName.LLC, (data) => {
          this.successDeleteQuestionnaireAnswers(data);
        })
      );

      this.queueService.add(this.prepareNavigateToCustomerStartPoint(this));
      // this.experimentService.setupExperiments();
      return this.queueService.process();
    } else {
      console.log('App Initialization. Else condition. ');
      return this.NavigateToCustomerStartPoint(this, '');
    }
  }

  // timestringExists() {
  //   if (this.userService.user.timestring === undefined || !this.userService.user.timestring || this.userService.user.timestring.length === 0) {
  //     this.userService.user.timestring = this.cookieService.get(this.environmentService.getTimestringCookie());
  //   }
  //   return (this.userService.user.timestring && this.userService.user.timestring.length > 0) ? true : false;
  // }

  private NavigateToCustomerStartPoint(context, url): Observable<boolean> {
    let returnValue = true;
    if (url) {
      this.navigateToURL(url);
    } else if (this.utilityService.getStringParamFromQueryString('entity')) {
      this.llcQuestionnaireService.LLC = new LLC();
      this.llcQuestionnaireService.LLC.entityName = this.utilityService.getStringParamFromQueryString('entity');
      this.appService.app = createAppState({});
      const navigationURL = './' + Chapter.Name + '/' + PagePath.BusinessState;
      this.navigateToURL(navigationURL);
    } else if (this.utilityService.getStringParamFromQueryString('choose_later')) {
      this.llcQuestionnaireService.LLC = new LLC();
      this.llcQuestionnaireService.LLC.entityName = null;
      this.appService.app = createAppState({});
      const navigationURL = './' + Chapter.Name + '/' + PagePath.BusinessState;
      this.navigateToURL(navigationURL);
    } else if (this.utilityService.getStringParamFromQueryString('state')) {
      this.llcQuestionnaireService.LLC = new LLC();
      this.llcQuestionnaireService.LLC.entityState = this.utilityService.getStringParamFromQueryString('state');
      this.appService.app = createAppState({});
      const navigationURL = './' + Chapter.Name + '/' + PagePath.NameAvailable;
      this.navigateToURL(navigationURL);
    } else {
      if (window.location.href.indexOf('localhost') < 0) {
        window.location.href = PagePath.LLCLandingPage;
        returnValue = true;
      } else {
        this.navigateToURL(`./${Chapter.Name}/${PagePath.ChangeName}`);
      }
    }
    return of(returnValue);
  }

  private navigateToURL(url: string) {
    const currentUrl = this.currentRoutePath.indexOf('?') > 0 ? this.currentRoutePath.substring(0, this.currentRoutePath.indexOf('?')) : this.currentRoutePath;

    if (currentUrl !== url) {
      this.router.navigate([url]);
    }
  }

  private setllcInSession(data: any) {
    const llc = this.llcQuestionnaireService.llc;
    const jsonObj: any = JSON.parse(data.answers);
    const llcObj: LLC = jsonObj as LLC;
    this.llcQuestionnaireService.setLLC(llcObj);

    // Object.keys(llc).forEach(property => {
    //   llc[property] = llcObj[property];
    // });

    // this.llcQuestionnaireService.llc = llc;
  }

  successDeleteQuestionnaireAnswers(response) {
    if (response) {
      this.llcQuestionnaireService.llc = new LLC();
    }
  }

  private prepareNavigateToCustomerStartPoint(context: any): IQueueEntry {
    const that = this;
    return {
      name: 'prepareValidateSession app-initialization.service',
      pre: () => {
        return of(true);
      },
      post: (response) => {
        const readOnlyAppState = this.appService.app;

        if (readOnlyAppState && readOnlyAppState.processingOrderId && readOnlyAppState.orderId) {
          if (!readOnlyAppState.isQuestionnaireComplete) {
            return context.NavigateToCustomerStartPoint(context, `./${Chapter.PostOrder}/${PagePath.RemainingQuestions}`);
          } else {
            return context.NavigateToCustomerStartPoint(context, '');
          }
        } else if (readOnlyAppState && readOnlyAppState.cartId && readOnlyAppState.processingOrderId) {
          let getUrl = null;
          if (this.llcQuestionnaireService.llc.currentView === `${Chapter.Checkout}/${PagePath.Checkout}`) {
            getUrl = `./${Chapter.Package}/${PagePath.BofA}`;
          } else {
            getUrl = `./${this.llcQuestionnaireService.llc.currentView}`;
          }
          if (this.llcQuestionnaireService.llc.currentView === undefined || this.llcQuestionnaireService.llc.currentView === null) {
            return context.NavigateToCustomerStartPoint(context, '');
          } else {
            return context.NavigateToCustomerStartPoint(context, getUrl);
          }
        } 
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        this.trackjsErrorLogService.track(ProductName.LLC, 'app-initialization.service', error);
        return of(null);
      }
    };
  }
}
